import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import apiUrl from "../../config";
import HealingIcon from "@mui/icons-material/Healing";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import salary from "../../data/salary";
import RotateRightIcon from "@mui/icons-material/RotateRight";
const PlayerCard = ({
  player,
  colors,
  team,
  updatePlayerPoints,
  mostGoals,
  mostPoints,
  injurieStatus,
  scratchedStatus,
}) => {
  const [playerId, setPlayerId] = useState(player.id); // e.g., Connor McDavid
  const [colorsTeam, setcolors] = useState(colors);
  const [score, setScore] = useState(null); // you can fetch this too from CapFriendly if needed
  const [pointsPerMinute, setpointsPerMinute] = useState(0);
  const [goals, setGoals] = useState(0);
  const [points, setPoints] = useState(0);
  const [plusMinus, setPlusMinus] = useState(0);
  const [gamesPlayed, setGamesPlayed] = useState(0);
  const [savePctg, setSavePctg] = useState(0);
  const [shutouts, setShutouts] = useState(0);
  const [playerFullName, setPlayerFullName] = useState(
    `${player.firstName.default} ${player.lastName.default}`,
  );
  const [playerInjury, setPlayerInjury] = useState(injurieStatus);
  const [playersScratched, setPlayersScratched] = useState(scratchedStatus);

  const IsMostGoals = mostGoals ? "superStarGoal" : "";
  const IsMostPoints = mostPoints ? "superStarPoint" : "";

  const injuriestatue = playerInjury ? "injured" : "healthy";

  const [salaryPlayer, setSalaryPlayer] = useState("");
  const [salaryNumber, setSalaryNumber] = useState("");

  const fetchPlayerStats = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/player/${playerId}`);
      const data = response.data;
      const currentYear = new Date().getFullYear();

      console.log("Fetched Player Data:", data);

      const nhlRegularSeasons = data.seasonTotals.filter((season) => {
        const seasonYearString = season.season ? season.season.toString() : "";
        const seasonStartYear = parseInt(seasonYearString.slice(0, 4), 10); // Extract starting year
        const seasonEndYear = parseInt(seasonYearString.slice(4), 10); // Extract ending year

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // Months are 0-indexed, so add 1

        // Determine the current NHL season's start and end years
        const currentSeasonStartYear =
          currentMonth >= 10 ? currentYear : currentYear - 1;
        const currentSeasonEndYear =
          currentMonth >= 10 ? currentYear + 1 : currentYear;

        return (
          season.leagueAbbrev === "NHL" && // Ensure it's an NHL season
          season.gameTypeId === 2 && // Ensure it's a regular season
          seasonStartYear === currentSeasonStartYear && // Match the start year of the current season
          seasonEndYear === currentSeasonEndYear // Match the end year of the current season
        );
      });
      console.log("NHL Regular Seasons Data:", nhlRegularSeasons);
      const combinedStats = nhlRegularSeasons.reduce((acc, season) => {
        const seasonKey = season.season; // Group by season
        if (!acc[seasonKey]) {
          acc[seasonKey] = { ...season }; // Initialize with the first entry
        } else {
          // Aggregate stats
          acc[seasonKey].goals += season.goals || 0;
          acc[seasonKey].assists += season.assists || 0;
          acc[seasonKey].gamesPlayed += season.gamesPlayed || 0;
          acc[seasonKey].plusMinus += season.plusMinus || 0;
          acc[seasonKey].savePctg = season.savePctg || acc[seasonKey].savePctg; // Use latest savePctg
          acc[seasonKey].shutouts += season.shutouts || 0;
        }
        return acc;
      }, {});

      // Get the most recent season
      const mostRecentSeasonKey = Math.max(...Object.keys(combinedStats));
      const latest = combinedStats[mostRecentSeasonKey];

      const stats = {
        season: latest.season,
        avgToi: latest.avgToi,
        goals: latest.goals,
        assists: latest.assists,
        gamesPlayed: latest.gamesPlayed,
        plusMinus: latest.plusMinus,
        savePctg: latest.savePctg,
        shutouts: latest.shutouts,
      };

      const {
        goals,
        assists,
        gamesPlayed,
        plusMinus,
        avgToi,
        savePctg,
        shutouts,
      } = stats;

      const points = goals + assists;
      setGoals(goals);
      setPoints(points);
      const pointsPerGame = points / gamesPlayed;

      if (player.positionCode != "G") {
        const toiSec =
          parseInt(avgToi.split(":")[0]) + parseInt(avgToi.split(":")[1]) / 60;
        const pointsPerSec = points / gamesPlayed;
        // Custom value formula (scale as you like)
        // if(player.positionCode === "G")
        // {const valueScore = (savePctg * gamesPlayed) / losses}
        // else {const valueScore = (pointsPerSec + plusMinus) / 2};

        const valueScore = (points + plusMinus) / toiSec; // Simplified formula for demonstration
        // pointsPerSec +
        //(pointsPerSec + plusMinus) / 2

        //   goals * 0.6 +
        //   assists * 0.4 +
        //   pointsPerGame * 10 +
        //   plusMinus * 0.25 +
        //toiMinutes * 5;
        setpointsPerMinute(pointsPerSec * 60);
        setScore(valueScore);
      } else {
        //          console.log("Goalie Stats:", stats);
      }
      setPlusMinus(plusMinus);
      setGamesPlayed(gamesPlayed);
      setSavePctg(savePctg);
      setShutouts(shutouts);
    } catch (error) {
      console.error("Error fetching player stats:", error);
    }
  };

  useEffect(() => {
    fetchPlayerStats();
  }, [playerId]);

  useEffect(() => {
    updatePlayerPoints(playerId, points, goals);
  }, [playerId, points, goals, updatePlayerPoints]);

  function normalizeTeamName(name) {
    return name
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents
      .replace(/\./g, "") // Remove periods
      .replace(/\s+/g, "_") // Replace spaces with underscores
      .toLowerCase(); // Optional: lowercase
  }

  function salaryFormatter(salary) {
    return Math.round(salary)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  useEffect(() => {
    const teamName = normalizeTeamName(team.fullName);
    const teamSalaryObj = salary.find((obj) => obj.hasOwnProperty(teamName));
    const salaryTeam = teamSalaryObj ? teamSalaryObj[teamName] : [];
    const salaryObj = salaryTeam.find(
      (item) =>
        item.player ===
        playerFullName.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
    );
    const salary2025 = salaryObj ? salaryObj.salary2025 : "N/A";
    const salaryInNumber =
      salary2025 !== "N/A" ? parseInt(salary2025.replace(/[\$,]/g, "")) : "N/A";
    setSalaryNumber(salaryInNumber);
    setSalaryPlayer(salary2025);
  }, [player, salary]);
  let plusMinusSymbole = `${plusMinus}`;
  if (plusMinus > 0) {
    plusMinusSymbole = `+${plusMinus}`;
  }

  return (
    <Link to={`/player/${player.id}`} state={{ player, colorsTeam, team }}>
      <div
        className="wrapperCard"
        style={{
          background: colorsTeam[0],
          border: `2px solid ${colorsTeam[0]}`,
        }}
      >
        <div
          id={player.id}
          key={player.id}
          className={`card ${injuriestatue} ${IsMostGoals} ${IsMostPoints}`}
          style={{
            background: `linear-gradient(105deg, ${colorsTeam[0]} 45%, ${colorsTeam[1]} 45%, ${colorsTeam[1]} 70%, ${colorsTeam[2]} 70%)`,
          }}
        >
          <div className="HealingIcon">
            {injuriestatue === "injured" && (
              <HealingIcon
                style={{
                  verticalAlign: "bottom",
                  marginLeft: "5px",
                  fontSize: "36px",
                }}
              />
            )}
            {IsMostPoints === "superStarPoint" && (
              <EmojiEventsIcon
                style={{
                  verticalAlign: "bottom",
                  marginLeft: "5px",
                  fontSize: "36px",
                  color: `${colorsTeam[1]}`,
                }}
              />
            )}
            {IsMostGoals === "superStarGoal" && (
              <MilitaryTechIcon
                style={{
                  verticalAlign: "bottom",
                  marginLeft: "5px",
                  fontSize: "36px",
                  color: `${colorsTeam[1]}`,
                }}
              />
            )}
            {playersScratched === false && injuriestatue != "injured" && (
              <RotateRightIcon
                style={{
                  verticalAlign: "bottom",
                  marginLeft: "5px",
                  fontSize: "36px",
                  color: `${colorsTeam[1]}`,
                }}
              />
            )}
          </div>
          {/* <div className='score'>  {score !== null ? (Math.ceil(score * 100) / 100).toFixed(2) : "Loading..."}</div> */}
          <div className="sweaterNumber" style={{ color: colorsTeam[0] }}>
            {player.sweaterNumber}
          </div>
          <div className="headShot">
            <img src={player.headshot} />
          </div>
          <div
            className="playerName"
            style={{
              background:
                team.triCode === "NSH"
                  ? colorsTeam[2]
                  : team.triCode === "BOS"
                    ? colorsTeam[1]
                    : colorsTeam[0],
              borderTop: `1px solid ${colorsTeam[1]}`,
              color: `#ffffff`,
            }}
          >
            <p>
              <span className="mobile">
                {player.firstName.default.slice(0, 1)}.&nbsp;
              </span>
              <span className="desktop">{player.firstName.default} </span>
              <span>{player.lastName.default}</span>
              <sup>{player.positionCode}</sup>
            </p>
            {player.positionCode === "G" ? (
              <p className="stats">
                {savePctg?.toFixed(3)}% Shutouts: {shutouts} Game: {gamesPlayed}
              </p>
            ) : (
              <p className="stats">
                {goals} Goal(s) {points}pts {(points / gamesPlayed)?.toFixed(2)}
                pts/G {plusMinusSymbole}
              </p>
            )}

            <p className="stats">
              {salaryPlayer} {player.weightInPounds}lbs{" "}
              {Math.trunc(player.heightInInches / 12)}'
              {player.heightInInches % 12 > 0
                ? `${player.heightInInches % 12}"`
                : ""}
            </p>

            {player.positionCode != "G" && points > 0 ? (
              <p className="stats">
                ${salaryFormatter(salaryNumber / points)}/pts
              </p>
            ) : (
              <p className="stats">&nbsp;</p>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};
export default PlayerCard;
